import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import {Accordion, AccordionItem, AccordionItemHeading,AccordionItemButton,AccordionItemPanel,} from 'react-accessible-accordion';
class FaqsSwahili extends Component {
    state = {  }
    render() { 
        const mystyle = {
            height:'100vh',
            backgroundColor:'#d3d3d3'
        }
        const button = {
            width: '100%',
  margin: '2px',
  padding: '20px',
  border: '1px solid #fff',
  borderRadius: '4px',
  zIndex: 1,
  textAlign: 'left',
  outline: 'none',
  backgroundColor: '#fff',
  fontSize: '1.3em',
  fontWeight: 'bold',
  transition: '100s',

}
const panel = {
    margin: '0px',
    padding: '20px',
    fontSize: '1.2em',
    fontStyle: 'italic',
    backgroundColor: '#fff',
}
        return ( 
            <div style={mystyle}>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12 col-sm-12 col-md-12 px-0">
                      
                        <Accordion  allowZeroExpanded={true}>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Nawezaje kuingiza Uzito na Urefu wa mtoto wangu?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Bonyeza kitufe cha VIPIMO kwenye Dashibodi yako, kisha ingiza uzito (kg) na urefu (sm) wa mtoto wako.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Wapi naweza kupata msaada na habari zaidi kuhusu SmartGrowthDiary?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Unaweza kutembelea ofisi zetu ili kupata msaada na habari zaidi juu ya kutumia application yetu ya SmartGrowthDiary. Bonyeza kitufe cha WASILIANA NASI ili kupata mawasiliano yetu na mahali ofisi zetu zinapopatikana.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Ninawezaje kufuatilia maendeleo ya ukuaji ya mtoto wangu?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Bonyeza kitufe cha CHATI YA UKUAJI kwenye Dashibodi yako ili kuona maendeleo ya ukuaji ya mtoto wako. Unaweza kubadili chati ya ukuaji kutoka chati ya Urefu dhidi ya Uzito kwenda kwenye chati ya Umri dhidi ya Urefu.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Nawezaje kuona ushauri niliopewa siku za nyuma?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Bonyeza kitufe cha USHAURI WA LISHE kwenye Dashibodi yako, kisha bonyeza tarehe unayotaka kuona ujumbe wake.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Nawezaje kuona taarifa muhimu za mtoto wangu?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Ukishafanikiwa kuingia kwenye programu, bonyeza kitufe kilichopo juu kushoto na hapo utaweza kuona taarifa zote muhimu za mtoto wako.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Ninawezaje kubadilisha nenosiri?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Bonyeza kitufe cheupe kilichopo juu-kushoto, kisha chini ya orodha utapata chaguo la kubadilisha nenosiri.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Ninawezaje kujua kama mtoto wangu anakua vizuri?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Lazima ujaze uzito na urefu wa sasa wa mtoto wako, kisha utapokea ujumbe wa kuonyesha kama mtoto wako anakua vizuri au anahitaji msaada.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Nawezaje kujua kiwango ninachomnyonyesha mtoto wangu ni sahihi kwa siku? 
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Lazima ujaze uzito na urefu wa sasa wa mtoto wako, kisha utapokea ujumbe wa kuonyesha kama mtoto wako anakua vizuri au anahitaji msaada, ikiwa mtoto wako anahitaji msaada unapaswa kuingiza idadi ulizomnyonyesha kwa siku husika. Kisha utapokea ujumbe ambao unaonyesha kiwango ambacho mtoto wako amenyonyeshwa pamoja na kiwango kinachohitajika kwa siku.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Ninawezaje kujua kiwango ninachomlisha mtoto wangu ni sahihi kwa siku?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Lazima ujaze uzito na urefu wa sasa wa mtoto wako, kisha utapokea ujumbe wa kuonyesha kama mtoto wako anakua vizuri au anahitaji msaada, ikiwa mtoto wako anahitaji msaada unapaswa kuingiza chakula alichokula ambacho ni aina ya chakula, kiasi na uwiano. Kisha utapokea ujumbe unaoonyesha kiwango cha mtoto wako ulichomlisha pamoja na kiwango kinachohitajika kwa siku.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
            <AccordionItem>
                <AccordionItemHeading>
                    <AccordionItemButton style={button}>
                    Nawezaje kuingiza kiasi cha chakula nilichomlisha mtoto wangu?
                    </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel style={panel}>
                    <p>
                    Baada ya kuchagua chakula ulichomlisha mtoto wako kwa siku, utaweza kuingiza kiasi cha chakula kwa kubonyeza kitufe chenye jina la chakula husika.
                    </p>
                </AccordionItemPanel>
            </AccordionItem>
        </Accordion>
                        </div>
                    </div>
                </div>
            </div>
         );
    }
}
 
export default FaqsSwahili;